import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
  import { Bed, Bath, Car, Maximize2 } from "lucide-vue-next";
  import { formatPrice } from "@/helpers/transformation/price";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import { ProjectPageData } from "@/services/api/projectPageApi";

  interface Props {
    isOpen: boolean;
    house: HouseDesignInterface | null;
    selectedFacade: any | null;
    selectedColorScheme: any | null;
    selectedInclusion: any | null;
    selectedUpgrades: any[];
    selectedLot: any | null;
    projectPage: ProjectPageData | null;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ReserveHomeAndLotModal',
  props: {
    isOpen: { type: Boolean, default: false },
    house: { default: null },
    selectedFacade: { default: null },
    selectedColorScheme: { default: null },
    selectedInclusion: { default: null },
    selectedUpgrades: { default: () => [] },
    selectedLot: { default: null },
    projectPage: { default: null }
  },
  emits: ["close", "submit"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;

  const formData = ref({
    fullName: "",
    email: "",
    phone: "",
    timeframe: "3-6",
    preApproved: false,
    cashBuyer: false,
    notes: "",
  });

  const houseImage = computed(() => {
    if (props.selectedFacade?.photos?.[0]) {
      return props.selectedFacade.photos[0];
    }

    if (props.house?.photos?.[0]) {
      return props.house.photos[0];
    }

    return null;
  });

  const bathroomCount = computed(() => {
    if (!props.house) return null;

    return props.house.bathroom?.quantity ?? props.house.bathroom ?? null;
  });

  const hasSpecs = computed(() => {
    return (
      props.house &&
      (props.house.bedroom ||
        bathroomCount.value ||
        props.house.garage ||
        props.house.area)
    );
  });

  const displayPrice = computed(() => {
    if (!props.house || !props.selectedLot) return "$0";

    let total = (props.house.price || 0) + (props.selectedLot.price || 0);

    // Add facade price
    if (props.selectedFacade?.price) {
      total += props.selectedFacade.price;
    }

    // Add inclusion price
    if (props.selectedInclusion?.price) {
      total += props.selectedInclusion.price;
    }

    // Add upgrades
    if (props.selectedUpgrades?.length) {
      total += props.selectedUpgrades.reduce(
        (sum, upgrade) => sum + (upgrade.price || 0),
        0
      );
    }

    return formatPrice(total);
  });

  const handleSubmit = () => {
    console.log("Form submitted:", formData.value);
    // TODO: Implement actual submission logic later
    // For now, just log and close
    emit("submit", formData.value);
  };

const __returned__ = { props, emit, formData, houseImage, bathroomCount, hasSpecs, displayPrice, handleSubmit, ref, computed, get Bed() { return Bed }, get Bath() { return Bath }, get Car() { return Car }, get Maximize2() { return Maximize2 }, get formatPrice() { return formatPrice }, get HouseDesignInterface() { return HouseDesignInterface }, get ProjectPageData() { return ProjectPageData } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})